import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { logoutUser } from "../services/authService";
import { useToast } from "Components/Common/Toast/ToastContext";

export default function useLogout() {
  const navigate = useNavigate();
  const [loggingOut, setLoggingOut] = useState(false);
  const showToast = useToast();
  const handleLogout = async () => {
    setLoggingOut(true);
    const refreshToken = localStorage.getItem("refreshToken") ?? "";
    const res = await (logoutUser(refreshToken) as Promise<{
      error?: { message?: string } | null;
    }>);
    setLoggingOut(false);
    if (res?.error) {
      showToast("Cannot log out. Please try again.");
      return;
    }
    window.dispatchEvent(new CustomEvent("auth-logout"));
    localStorage.clear();
    sessionStorage.clear();
    localStorage.setItem("authChanged", Date.now().toString());
    navigate("/", { replace: true });
  };

  return { handleLogout, loggingOut };
}
